const setChoices = (state, choices) => state.choices = choices;

let mutations = {
  setChoices,
}

export default mutations;
